Ext.define('SA.StaticLimitCheck', {
    constructor({canExport}) {
        this._canExport = canExport;
    },

    canExport() {
        return this._canExport;
    },

    canHideWindow() {
        return true;
    },

    isBeyondLimit() {
        return false;
    },

    maybeGetMessage() {
        return null;
    }
});